export default "<p>qa-upload-report works!</p>\r\n";